import type { FC, ReactElement, ReactNode } from 'react';
import Tooltip from '@components/Tooltip';

import { Show } from './Show';

export interface FieldSchemaIdTooltipProps {
  cdrIds?: string[];
  cdrNames?: string[];
  schemaId?: string;
  fallbackName?: ReactNode;
  children: ReactElement;
  /**
   * Tooltip won't be rendered. Already takes into account `cdrId` and `cdrName` props.
   * Implemented as: `(!cdrId && !cdrName) || isDisabled`;
   */
  isDisabled?: boolean;
}

export const FieldSchemaIdTooltip: FC<FieldSchemaIdTooltipProps> = ({
  cdrIds,
  cdrNames,
  schemaId,
  children,
  fallbackName,
  isDisabled,
}) => {
  if (!cdrNames?.length || isDisabled) return <>{children}</>;

  return (
    <Tooltip
      content={cdrNames?.map((name, idx) => {
        const parsedSchemaId = cdrIds?.[idx] ?? schemaId;
        return (
          <div key={parsedSchemaId}>
            {name ?? fallbackName}
            <Show when={!!parsedSchemaId}>
              <span className="text-info-400 pl-1 text-xs"> {parsedSchemaId}</span>
            </Show>
          </div>
        );
      })}
    >
      <div>{children}</div>
    </Tooltip>
  );
};
